import React from "react";
import { Updater } from "use-immer";

import { IgListItemButton } from "@intelligems/ig-theme";
import {
  ChannelType,
  DeviceType,
  StatSigViewType,
  SubscriptionAnalyticsType,
  VisitorType,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

interface SubscriptionTypeFilterProps {
  onStringFilterChange: (
    newValue:
      | DeviceType
      | VisitorType
      | ChannelType
      | StatSigViewType
      | SubscriptionAnalyticsType,
    filterKey:
      | "statSigView"
      | "deviceType"
      | "channelType"
      | "visitorType"
      | "subscriptionType"
  ) => void;
  subscriptionType?: SubscriptionAnalyticsType | null;
}

export const subscriptionTypeList: {
  label: string;
  key: SubscriptionAnalyticsType;
}[] = [
  {
    label: "All Orders",
    key: "any",
  },
  {
    label: "One Time",
    key: "One Time",
  },
  {
    label: "Recurring",
    key: "Recurring",
  },
];

export const SubscriptionTypeFilter = ({
  subscriptionType,
  onStringFilterChange,
}: SubscriptionTypeFilterProps) => {
  const selectedCard = (newValue: string): boolean => {
    return subscriptionType === newValue;
  };
  return (
    <Grid container spacing={2} direction={"row"}>
      {subscriptionTypeList.map((subscriptionType) => (
        <Grid item xs={4} key={subscriptionType.key}>
          <IgListItemButton
            label={subscriptionType.label}
            onClick={() => {
              onStringFilterChange(subscriptionType.key, "subscriptionType");
            }}
            selected={selectedCard(subscriptionType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
